import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { useTranslation } from "react-i18next";
const Gallery = () => {

  const [selectedImage, setSelectedImage] = useState("");
  const { t } = useTranslation();
  const images = [
    "/cuscus.jpeg",
    "/Fish-Pettice.jpeg",
    "/Liver.jpg",
    "/matbucha.jpeg",
    "/pumkin.jpeg",
    "/potetos.jpg",
    "/Delivery.jpeg",
    "/meatBall.jpeg"
  ];

   return (
    <div className="container mt-4" dir="rtl">
      <h2 className="text-center mb-4">{t("gallery")}</h2>

      <div className="row g-3 p-5">
        {images.map((src, index) => (
          <div className="col-6 col-md-3" key={index}>
            <div className="ratio ratio-1x1 rounded overflow-hidden shadow-sm">
              <img
                src={src}
                alt={`img-${index}`}
                className="w-100 h-100 object-fit-cover"
                style={{ cursor: "pointer" }}
                data-bs-toggle="modal"
                data-bs-target="#imageModal"
                onClick={() => setSelectedImage(src)}
              />
            </div>
          </div>
        ))}
      </div>

      {/* Modal Bootstrap לתמונה מוגדלת */}
      <div
        className="modal fade"
        id="imageModal"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-fullscreen">
          <div className="modal-content bg-dark border-0">
            
            <div className="modal-header border-0">
              <button
                type="button"
                className="btn-close btn-close-white"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div className="modal-body d-flex justify-content-center align-items-center">
{selectedImage? <img
                src={selectedImage}
                alt="full-size"
                className="img-fluid rounded"
              />:null}
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Gallery;
